import { useQuery } from '@tanstack/react-query';
import { fetchLibraryTags } from '../../../api/libraryApi';

/**
 * Cached library-wide tag pool, used by:
 * - the TrackDetailPage tag editor (FR-017)
 * - the batch tag input on MultiUploadPage (FR-059)
 * - the tag filter on the standalone library + playlist track-picker (FR-060)
 *
 * The same query key (`['admin-library', 'tags']`) is shared across all consumers
 * so the suggestion list is fetched once per session and reused (TC-772).
 * Stale time is 5 minutes — long enough to amortize navigation, short enough that
 * newly-added tags surface within the same admin session.
 */
export function useLibraryTags() {
  return useQuery({
    queryKey: ['admin-library', 'tags'],
    queryFn: fetchLibraryTags,
    staleTime: 5 * 60 * 1000,
    select: (data) => data.tags,
  });
}
